module.exports = __webpack_public_path__ + "img/small.8b4dd991.jpg";